module.exports = __webpack_public_path__ + "static/media/logo_smarters.5f7d4b94.svg";